import React, { useState, useContext } from "react";
import { useRCAMainStyles } from "../RCA.styles";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, Typography } from "@mui/material";
import RCAComplianceFilters from "./components/filters/RCAAPComplianceFilters/RCAAPComplianceFilters.view";
import { useStyles } from "./RCAAPCompliance.styles";
import { RCAAPComplianceContext } from "contexts/RCAAPComplianceContext/RCAAPComplianceContext";
import RCACompliance from "./RCACompliance";
import APCompliance from "./APCompliance";
import { ComplianceTypes } from "constants/constants";

enum TabsEnum {
    rcaCompliance,
    actionPlanCompliance,
}

const RCAAPCompliance = () => {
    const mainClasses = useRCAMainStyles();
    const classes = useStyles();
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState(TabsEnum.rcaCompliance);
    const { handleSetComplianceType } = useContext(RCAAPComplianceContext);

    const tabs = [
        {
            id: TabsEnum.rcaCompliance,
            label: t("rca.compliance.tabs.rca_compliance"),
        },
        {
            id: TabsEnum.actionPlanCompliance,
            label: t("rca.compliance.tabs.ap_compliance"),
        },
    ];

    const tabsComponents = {
        [TabsEnum.rcaCompliance]: {
            component: <RCACompliance />,
        },
        [TabsEnum.actionPlanCompliance]: {
            component: <APCompliance />,
        },
    };

    return (
        <div className={mainClasses.mainWrapper}>
            <div className={classes.contentTitleContainer}>
                <Typography variant="rcaTitle" className={mainClasses.contentTitle}>
                    {t("rca.compliance.title")}
                </Typography>
                <RCAComplianceFilters />
            </div>
            <div className={classes.mainWrapper}>
                <Tabs
                    className={classes.tabs}
                    value={selectedTab}
                    onChange={(_, newValue) => {
                        setSelectedTab(newValue);
                        handleSetComplianceType(ComplianceTypes.NONE);
                    }}
                >
                    <Tab value={TabsEnum.rcaCompliance} label={tabs[TabsEnum.rcaCompliance].label} />
                    <Tab value={TabsEnum.actionPlanCompliance} label={tabs[TabsEnum.actionPlanCompliance].label} />
                </Tabs>
                <div>
                    {
                        // @ts-ignore
                        tabsComponents[selectedTab].component
                    }
                </div>
            </div>

            <div className={mainClasses.contentWrapper}></div>
        </div>
    );
};

export default RCAAPCompliance;
